import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=95d859b8&scoped=true"
import script from "./accountForm.vue?vue&type=script&lang=js"
export * from "./accountForm.vue?vue&type=script&lang=js"
import style0 from "./accountForm.vue?vue&type=style&index=0&id=95d859b8&prod&lang=less&scoped=true"
import style1 from "./accountForm.vue?vue&type=style&index=1&id=95d859b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d859b8",
  null
  
)

export default component.exports